module.exports = __webpack_public_path__ + "media/images/emblems/Crassier-coat_of_arms-6a36da05ce7e393fd36f41b24e339085.svg";